export default __webpack_public_path__ + "static/media/pokemon_img.9e23b064.png";